import "./shivalik.css";
import React from "react";
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Axios from "axios";
import swal from "sweetalert";
import Table from "react-bootstrap/Table";
import ReactDOM from "react-dom";
import image from "../../uploads/signature.png";
import image2 from "../../uploads/pinnacle_logo.png";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";

function Shivalik() {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [OrderID, setOrderID] = useState();
  const [selectedOrderID, setSelectedOrderID] = useState("");
  const [Currentstatus, setCurrentstatus] = useState("");

  const getStatusColor = (status) => {
    switch (status) {
      case "Work completed":
        return "Green";
      case "Work in Progress":
        return "blue";
      case "Work Not Start Yet":
        return "red";
      default:
        return "";
    }
  };

  useEffect(() => {
    Axios.get("http://13.200.156.92:5000/getOrder").then((response) => {
      setData(response.data);
    });
  }, []);

  useEffect(() => {
    Axios.get("http://13.200.156.92:5000/getbooksupplier").then((response) => {
      setData1(response.data);
    });
  }, []);

  const handleSaveClick = async () => {
    try {
      await Promise.all(
        data.map(async (user) => {
          await Axios.put(
            `http://13.200.156.92:5000/updateCurrentstatus/${user._id}`,
            {
              Currentstatus: user.Currentstatus,
            }
          );
        })
      );
      swal({
        title: "Currentstatus updated successfully",
        text: "",
        icon: "success",
      });
      window.location.reload();
    } catch (error) {
      console.error("Error updating Currentstatus:", error);
      alert("Error updating Currentstatus. Please try again.");
    }
  };

  const filteredData = data.filter((row) => row.ApprovalDate !== null);

  useEffect(() => {
    const filteredData2 = data.filter((row) => row.orderid === selectedOrderID);
    if (selectedOrderID !== "") {
      renderPDFContent(filteredData2);
    }
    console.log(filteredData2);
  }, [selectedOrderID]);
  const trimDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  let rowTotal = 0;

  const handleButtonClick = (orderID) => {
    setSelectedOrderID(orderID);
  };

  const renderPDFContent = (filteredData2) => {
    let subtotal = 0;
    let gst = 0;
    let total = 0;
    const itemsPerPage = 4;

    filteredData2.forEach((item) => {
      if (item.updatedQuantity) {
        item.updatedQuantity.forEach((updatedItem) => {
          const rowTotal =
            updatedItem.purchasePrice * updatedItem.approvedquantity;
        });
      }
    });

    // const calculateTotal = (useGST) => {
    //   gst = useGST ? subtotal * 0.18 : 0;
    //   total = subtotal + gst;
    // };

    const styles = StyleSheet.create({
      page: {
        flexDirection: "column",
      },
      section: {
        display: "flex",
        flexDirection: "row",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 15,
        marginBottom: 15,
      },
      title: {
        fontSize: 12,
      },
      listItem: {
        marginBottom: 0.5,
      },
      box: {
        border: "1px solid black",
      },
      stationView: {
        border: "1px solid black",
        padding: 5,
      },
      pdfhead: {
        textAlign: "center",
        marginTop: 16,
        marginBottom: 25,
      },
      pdfhead2: {
        textAlign: "left",
        marginLeft: 12,
        fontSize: 12,
      },
      pdfdetails: {
        fontSize: 12,
        marginLeft: 5,
      },
      pdfaddress: {
        fontSize: 12,
      },
      column: {
        flex: 1,
        border: "0px",
        marginLeft: 5,
        // marginRight: 5,
        border: "1px solid black",
      },
      column2: {
        flex: 1,
        border: "0px",
        // marginLeft: 5,
        marginRight: 5,
        border: "1px solid black",
      },

      details: {
        // marginBottom: 5,
        // backgroundColor: "cornflowerblue",
        textAlign: "center",
        fontSize: 14,
        fontWeight: "bold",
      },
      shipto: {
        // backgroundColor: "cornflowerblue",
        textAlign: "center",
        fontSize: 14,
        fontWeight: "bold",
      },

      second2: {
        fontSize: 12,
        marginLeft: 15,
      },
      address: {
        marginTop: 4,
        marginLeft: 5,
        fontSize: 10,
        marginBottom: 9,
      },

      secondrow: {
        border: "1px solid black",
        marginLeft: 10,
        marginRight: 10,
        marginTop: 8,
      },
      thirdrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
      forthrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
      thirdrowquantity: {
        marginLeft: 220,
        fontSize: 12,
      },
      gst: {
        marginLeft: 380,
        fontSize: 12,
        position: "absolute",
      },
      thirdrowbox: {
        border: "1px solid black",
        marginLeft: 5,
        marginRight: 280,
        marginTop: 5,
        marginBottom: 10,
      },
      GD: {
        marginLeft: 380,
        fontSize: 12,
      },
      TA: {
        fontSize: 12,
        marginBottom: 10,
      },
      PP: {
        fontSize: 12,
        marginLeft: 400,
        marginBottom: 10,
        marginTop: 5,
      },
      signature: {
        fontSize: 12,
        // marginTop: 20,
        marginLeft: 400,
        marginBottom: 10,
      },

      pdfContent: {
        marginBottom: 10,
      },

      table: {
        marginTop: 10,
        marginBottom: 10,
        fontSize: 12,
      },
      tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "black",
        paddingBottom: 5,
        marginBottom: 5,
        fontSize: 7,
      },
      tableCell: {
        flex: 1,
        padding: 5,
        fontSize: 10,
      },
      tableHeaderCell: {
        fontWeight: "bold",
      },

      comments: {
        border: "1px solid black",
      },
      commentInstruction: {
        backgroundColor: "grey",
      },
      commentbox: {
        border: "1px solid black",
        // padding: 22,
        marginLeft: 4,
        marginRight: 210,
        height: 62,
      },

      underline: {
        marginLeft: 176,
        textAlign: "center",
        fontSize: 12,
      },
      underline2: {
        marginTop: -79,
        marginLeft: 470,
        marginRight: 50,
        textAlign: "center",
        fontSize: 12,
      },
      col1: {
        display: "flex",
        flexDirection: "row",
        marginLeft: 222,
        marginTop: 14,
      },

      filtered2: {
        position: "absolute",
        marginLeft: 450,
        marginTop: 56,
      },
      suppliername1: {
        fontSize: 14,
        marginBottom: 12,
        marginTop: 5,
        textAlign: "center",
      },
      suppliername: {
        fontSize: 14,
        marginBottom: 12,
        marginTop: 5,
        textAlign: "center",
      },
      logo: {
        marginRight: 442,
        marginTop: 5,

        position: "absolute",
      },
      mainview: {
        marginLeft: 15,
        marginRight: 15,
      },
    });
    let totalCount = 0;

    const pdfContent = (
      <Document>
        {filteredData2.map((item, index) => {
          if (item.updatedQuantity) {
            const numPages = Math.ceil(
              item.updatedQuantity.length / itemsPerPage
            );

            return Array.from({ length: numPages }).map((_, pageIndex) => {
              const startIndex = pageIndex * itemsPerPage;
              const endIndex = startIndex + itemsPerPage;
              const itemsToRender = item.updatedQuantity.slice(
                startIndex,
                endIndex
              );

              const isLastPage = pageIndex === numPages - 1;
              return (
                <Page key={index} style={styles.page}>
                  <View style={styles.mainview}>
                    <View>
                      <View style={styles.logo}>
                        <Image
                          src={image2}
                          style={{
                            width: 150,
                            height: 60,
                            marginLeft: 12,
                            marginBottom: 5,
                          }}
                        />
                      </View>
                      <Text style={styles.pdfhead}>Purchase Order</Text>
                      <Text style={styles.pdfhead2}>
                        PINNACLE CIVIL SERVICES
                      </Text>
                      <Text style={styles.pdfhead2}>
                        1st Floor, 1032A, MM Tower, New Railway Road,
                      </Text>
                      <Text style={styles.pdfhead2}>
                        Dayanand Colony, Gurugram, Haryana 122006 Code: 06
                      </Text>

                      <View style={styles.filtered2}>
                        {filteredData2.map((item, index) => {
                          return (
                            <View>
                              <View>
                                <Text>Order No: {item.orderid}</Text>
                              </View>
                            </View>
                          );
                        })}
                      </View>
                    </View>

                    <View style={styles.section}>
                      <View style={styles.column}>
                        <View>
                          <View style={styles.details}>
                            <Text>Vendor:-</Text>
                          </View>
                          {data1.map((ite) => (
                            <View key={ite.id}>
                              <Text style={styles.suppliername}>
                                {ite.Booksupplier}
                              </Text>
                              <Text style={styles.address}>{ite.Address}</Text>
                            </View>
                          ))}
                        </View>
                      </View>
                      <View style={styles.column2}>
                        <View>
                          <Text style={styles.shipto}>Ship To:-</Text>
                          <Text style={styles.suppliername1}>
                            Pinnacle Publications
                          </Text>
                          <Text style={styles.address}>
                            Hare Ram Plaza Basement, old Railway road, sector-4
                            nearby chintapurni mandir Below redtap showroom,
                            gurugram, Haryana, 122001
                          </Text>
                        </View>
                      </View>
                    </View>

                    <View style={styles.secondrow}>
                      <View style={styles.table}>
                        <View style={[styles.tableRow, styles.tableHeaderCell]}>
                          <View style={styles.tableCell}>
                            <Text>SN</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Descriptions</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text> {"           "}Image</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Quantity</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Unit Price</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Total</Text>
                          </View>
                        </View>
                        {itemsToRender.map((updatedItem, updatedIndex) => {
                          // const rowTotal =
                          //   updatedItem.purchasePrice * updatedItem.approvedquantity;
                          rowTotal =
                            updatedItem.purchasePrice *
                            updatedItem.approvedquantity;
                          subtotal += rowTotal;
                          gst = subtotal * 0.18;
                          total = subtotal + gst;
                          totalCount++;
                          setOrderID(item.orderid);
                          return (
                            <View key={updatedIndex} style={styles.tableRow}>
                              <View style={[styles.tableCell, { flex: 0.5 }]}>
                                <Text>{totalCount}</Text>
                              </View>
                              <View style={[styles.tableCell, { flex: 2 }]}>
                                <View>
                                  <Text>{updatedItem.title}</Text>
                                </View>
                                <View>
                                  <Text>Medium: {updatedItem.Medium}</Text>
                                </View>
                                <View>
                                  <Text>Edition: {updatedItem.edition}</Text>
                                </View>
                              </View>
                              <View style={[styles.tableCell, { flex: 1 }]}>
                                <Image
                                  src={updatedItem.img}
                                  style={{
                                    width: 60,
                                    height: 60,
                                  }}
                                />
                              </View>
                              <View style={[styles.tableCell, { flex: 1 }]}>
                                <Text>{updatedItem.approvedquantity}</Text>
                              </View>
                              <View style={[styles.tableCell, { flex: 1 }]}>
                                <Text>
                                  {updatedItem.purchasePrice.toFixed(2)}
                                </Text>
                              </View>
                              <View style={[styles.tableCell, { flex: 1 }]}>
                                <Text>{rowTotal.toFixed(2)}</Text>
                              </View>
                            </View>
                          );
                        })}
                      </View>
                    </View>
                    {isLastPage && (
                      <View>
                        <View style={styles.col1}>
                          <View style={styles.underline}>
                            <Text>Subtotal</Text>
                            <Text>Tax</Text>
                            <Text>Shipping</Text>
                            <Text>Others</Text>
                            <Text>GST@18%</Text>
                            <Text>Total</Text>
                          </View>
                        </View>
                        <View>
                          <View style={styles.underline2}>
                            <Text>{subtotal.toFixed(2)}</Text>
                            <Text>-</Text>
                            <Text>-</Text>
                            <Text>-</Text>
                            <Text>{gst.toFixed(2)}</Text>
                            <Text>{total.toFixed(2)}</Text>
                          </View>
                        </View>
                      </View>
                    )}

                    {isLastPage && (
                      <View style={styles.forthrow}>
                        <Text style={styles.PP}>
                          For Pinnacle Civil Services
                        </Text>
                        <Image
                          src={image}
                          style={{ width: 100, height: 50, marginLeft: 410 }}
                        />
                        <Text style={styles.signature}>
                          Authorized Signature
                        </Text>
                      </View>
                    )}
                    <View style={styles.pageFooter}></View>
                  </View>
                </Page>
              );
            });
          }
        })}
      </Document>
    );

    const newWindow = window.open();
    ReactDOM.render(
      <PDFViewer width="100%" height="100%">
        {pdfContent}
      </PDFViewer>,
      newWindow.document.body
    );
  };

  const handleCurrentstatusChange = (index, selectedCurrentstatus) => {
    const newData = [...data];
    newData[index].Currentstatus = selectedCurrentstatus;
    setData(newData);
  };

  return (
    <div>
      <div className="purchase">
        <h4>Purchase Order</h4>
      </div>
      <br />
      <Table stripeh className="purchasetable">
        <thead>
          <tr>
            <th>PO.NO</th>

            <th>Date</th>
            <th>Title</th>
            <th>Medium</th>
            <th>SKU</th>
            <th>Quantity</th>

            <th>PO</th>
            <th>Change Status</th>
            <th>Current Status</th>

            <th>Action</th>
          </tr>
        </thead>
        <br />

        <tbody>
          {filteredData.map((row, index) => (
            <tr key={row.orderid}>
              <td>{row.orderid}</td>
              <td>{row.ApprovalDate}</td>
              <td>
                {row.updatedQuantity
                  .map((item) => item.title)
                  .map((sku, index) => (
                    <React.Fragment key={index}>
                      {sku}
                      <br />
                    </React.Fragment>
                  ))}
              </td>

              <td>
                {row.updatedQuantity
                  .map((item) => item.Medium)
                  .map((sku, index) => (
                    <React.Fragment key={index}>
                      {sku}
                      <br />
                    </React.Fragment>
                  ))}
              </td>

              <td>
                {row.updatedQuantity
                  .map((item) => item.sku)
                  .map((sku, index) => (
                    <React.Fragment key={index}>
                      {sku}
                      <br />
                    </React.Fragment>
                  ))}
              </td>

              <td>
                {row.updatedQuantity
                  .map((item) => item.approvedquantity)
                  .map((sku, index) => (
                    <React.Fragment key={index}>
                      {sku}
                      <br />
                    </React.Fragment>
                  ))}
              </td>

              <td>
                <Button onClick={() => handleButtonClick(row.orderid)}>
                  Show PDF
                </Button>
              </td>
              <td>
                <select
                  value={Currentstatus.Currentstatus || "Select Currentstatus"}
                  onChange={(e) =>
                    handleCurrentstatusChange(index, e.target.value)
                  }
                >
                  <option disabled>Select Currentstatus</option>
                  <option value="Work Not Start Yet">Work Not Start Yet</option>
                  <option value="Work in Progress">Work in Progress</option>
                  <option value="Work completed">Work completed</option>
                </select>
              </td>

              <td style={{ color: getStatusColor(row.Currentstatus) }}>
                {row.Currentstatus}
              </td>

              <td>
                <Button onClick={handleSaveClick}>Update</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default Shivalik;
